import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import AddToCart from 'yoda-site-components/lib/components/AddToCart/AddToCart';
import AddToCartInterstitial from 'yoda-checkout-components/lib/components/AddToCartInterstitial/AddToCartInterstitial';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { connect } from 'react-redux';
import ToolTip from '../../components/Tooltip/Tooltip';
import * as styles from './CustomAddToCart.css';

const cx = classNames.bind(styles);

class CustomAddToCart extends Component {
    static propTypes = {
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCartActions: PropTypes.objectOf(PropTypes.object).isRequired,
        isOOSAlert: PropTypes.bool.isRequired,
        LoaderAction: PropTypes.objectOf(PropTypes.object).isRequired,
        productDetails: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCartClicked: PropTypes.func.isRequired,
        buttonTheme: PropTypes.objectOf(PropTypes.object),
        analyticsData: PropTypes.objectOf(PropTypes.object),
        messagesTexts: PropTypes.objectOf.isRequired,
        isOutOfStock: PropTypes.bool.isRequired,
        productId: PropTypes.string,
        addToCartListItemId: PropTypes.string,
    };

    static defaultProps = {
        analyticsData: {},
        buttonTheme: {},
        productId: '',
        addToCartListItemId: '',
    };

    constructor() {
        super();
        this.state = {
            showError: false,
            errorMessages: undefined,
        };

        this.closeCartModal = this.closeCartModal.bind(this);
        this.removeLoader = this.removeLoader.bind(this);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.addToCart !== this.props.addToCart &&
            nextProps.addToCart.error &&
            nextProps.addToCart.error.ppId === nextProps.productDetails.data[0].ppId &&
            nextProps.addToCart.error.skuId === nextProps.productDetails.data[0].skuId
        ) {
            this.setState({ showError: true });
            /* istanbul ignore next */
            setTimeout(() => {
                this.setState({ showError: false });
            }, 6000);
        }
    }

    shouldComponentUpdate() {
        return !this.state.errorMessages;
    }

    removeLoader() {
        /* istanbul ignore next */
        this.props.LoaderAction.removeLoader();
    }

    closeCartModal() {
        /* istanbul ignore next */
        // this.props.actions.updateItemCountAction();
        this.props.addToCartActions.closeCartModal();
    }

    render() {
        const {
            addToCart,
            buttonTheme,
            productDetails,
            analyticsData,
            addToCartClicked,
            isOOSAlert,
            messagesTexts,
            isOutOfStock,
            productId,
            addToCartListItemId,
        } = this.props;
        let errorMessages;
        if (!this.state.errorMessages && addToCart.error) {
            errorMessages = get(
                addToCart.error,
                'response.data[0].errorMessage',
                get(addToCart.error, 'response.data.data[0].errors[0].errorMessage', '')
            );
        }
        const { showError } = this.state;
        const productDetailsList = productDetails.data[0];
        const { quantity = 1 } = productDetailsList;
        const customClassName = [cx('addToCartBlock')];
        buttonTheme && customClassName.push(buttonTheme);
        // to make sure only one slider opens on ATC
        const isAtcClicked = productId === addToCartListItemId;
        return (
            <div className={`${cx('customAddToCartWrapper')} ${dt(['relative', 'text-left'])}`}>
                {showError &&
                    errorMessages &&
                    addToCart.error.ppId === productDetailsList.ppId &&
                    addToCart.error.skuId === productDetailsList.skuId && (
                        <div
                            className={`${cx('infoContainer')} ${dt([
                                'absolute',
                                'bottom-[40px]',
                                'md:right-[0px]',
                            ])}`}
                        >
                            <ToolTip
                                isVisible
                                className={`${cx('errorTooltip')} ${dt(['border-none'])}`}
                            >
                                {errorMessages}
                            </ToolTip>
                        </div>
                    )}
                <AddToCart
                    addToCart={addToCart}
                    productDetails={productDetails}
                    buttonSize="Lg"
                    buttonType="Secondary"
                    buttonText={
                        isOOSAlert
                            ? messagesTexts.myListing.getInStockAlert
                            : messagesTexts.myListing.addToCart
                    }
                    buttonTheme={buttonTheme}
                    customClassName={customClassName.join(' ')}
                    analyticsData={analyticsData}
                    addToCartClicked={addToCartClicked}
                    from="listing"
                    isOOSAlert={isOOSAlert}
                    isOutOfStock={isOutOfStock}
                />
                {addToCart.isAddToCartSuccess &&
                    addToCart.from &&
                    addToCart.ppId === productDetailsList.ppId &&
                    isAtcClicked && (
                        <AddToCartInterstitial
                            key={productDetailsList.ppId + productDetailsList.skuId}
                            sku={addToCart.skuId}
                            showAddToCart={addToCart.isAddToCartSuccess}
                            ppId={addToCart.ppId}
                            onCloseAddToCart={this.closeCartModal}
                            removeLoader={this.removeLoader}
                            numberOfItems={quantity}
                        />
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    addToCartListItemId: state.MyList?.addToCartListItemId,
});

export default connect(mapStateToProps, null)(CustomAddToCart);
